// Testimonials service - Hardcoded data only (Supabase integration removed)
import { testimonials as hardcodedTestimonials } from '../data/testimonials';

// Get all testimonials (hardcoded only)
export const getAllTestimonials = async () => {
    // Simulate async delay
    await new Promise(resolve => setTimeout(resolve, 500));
    return [...hardcodedTestimonials];
};

// Get approved testimonials
export const getApprovedTestimonials = async () => {
    const allTestimonials = await getAllTestimonials();
    return allTestimonials.filter(t => t.approved);
};

// Get featured testimonials
export const getFeaturedTestimonials = async () => {
    const allTestimonials = await getAllTestimonials();
    return allTestimonials.filter(t => t.approved && t.featured);
};

// Get testimonials by industry
export const getTestimonialsByIndustry = async (industry) => {
    const allTestimonials = await getAllTestimonials();
    return allTestimonials.filter(t => t.approved && t.industry === industry);
};

// Submit a new testimonial (Local simulation only)
export const submitTestimonial = async (testimonialData) => {
    // Simulate network delay
    await new Promise(resolve => setTimeout(resolve, 1000));

    // Save to localStorage to simulate persistence
    const existingReviews = JSON.parse(localStorage.getItem('pendingReviews') || '[]');
    existingReviews.push({
        ...testimonialData,
        submittedAt: new Date().toISOString(),
        approved: false
    });
    localStorage.setItem('pendingReviews', JSON.stringify(existingReviews));

    console.log('Testimonial submitted locally:', testimonialData);
    return { success: true, method: 'localStorage-simulated' };
};

export default {
    getAllTestimonials,
    getApprovedTestimonials,
    getFeaturedTestimonials,
    getTestimonialsByIndustry,
    submitTestimonial
};
